import { render, staticRenderFns } from "./CheckSign.vue?vue&type=template&id=648be666&scoped=true&"
import script from "./CheckSign.vue?vue&type=script&lang=js&"
export * from "./CheckSign.vue?vue&type=script&lang=js&"
import style0 from "./CheckSign.vue?vue&type=style&index=0&id=648be666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648be666",
  null
  
)

export default component.exports